import React from 'react';
import { NavLink } from 'react-router-dom';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

class OurProject extends React.Component {
    state = {
        projects: [],
        services: [],
        loading: true
    };

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const [projectsRes, servicesRes] = await Promise.all([
                axiosClient.get(apiConfig.PROJECTS.GET_ALL + '?per_page=10'),
                axiosClient.get(apiConfig.SERVICES.GET_ALL)
            ]);

            this.setState({
                projects: projectsRes.data.data,
                services: servicesRes.data.data,
                loading: false
            }, () => {
                // Initialize jQuery plugins after React renders the new elements
                if (window.initMasonryAndPopup) {
                    setTimeout(() => {
                        window.initMasonryAndPopup();
                    }, 100);
                }
            });
        } catch (error) {
            console.error("Error fetching data", error);
            this.setState({ loading: false });
        }
    }

    render() {
        const { projects, services, loading } = this.state;

        if (loading) return <div className="text-center p-a50">Loading...</div>;

        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b30 square_shape2 ">
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Project</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        <div className="section-content">
                            <div className="portfolio-wrap row mfp-gallery product-stamp clearfix">
                                {/* COLUMNS 1 */}
                                <div className="stamp col-md-3 col-sm-6 m-b30">
                                    <div className="bg-gray p-a30">
                                        <div className="filter-wrap">
                                            <ul className="filter-navigation masonry-filter text-uppercase">
                                                <li className="active"><NavLink to={"#"} data-filter="*" data-hover="All">All</NavLink></li>
                                                {services.map((item, index) => (
                                                    <li key={index}><NavLink to={"#"} data-filter={`.cat-${item.slug}`} data-hover={item.name}>{item.name}</NavLink></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {/* COLUMNS 2 */}
                                {projects.map((item, index) => {
                                    const filterClass = item.service ? `cat-${item.service.slug}` : '';
                                    const isWide = index === 7 ? 'col-md-6' : 'col-md-3';
                                    return (
                                        <div key={index} className={`${filterClass} masonry-item ${isWide} col-sm-6 m-b30`}>
                                            <div className="mt-box image-hover-block">
                                                <div className="mt-thum-bx">
                                                    <img src={item.featured_image} alt={item.title} />
                                                </div>
                                                <div className="mt-info p-t20 text-white">
                                                    <h4 className="mt-tilte m-b10 m-t0">{item.title}</h4>
                                                    <p className="m-b0">{item.location || 'Location Not Specified'}</p>
                                                </div>
                                                <NavLink to={`/project-detail`} state={{ projectSlug: item.slug }}></NavLink>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="hilite-title text-left p-l50 text-uppercase text-pop-up-top">
                        <strong>Projects</strong>
                    </div>
                </div>
            </>
        );
    }
};

export default OurProject;
